﻿﻿﻿<h2>SetConfiguration Template during provisioning for {{defaults.controllertype.Description}} and {{defaults.tenant}}</h2>
<div style="display:flow-root">
    <div style="float:left; width:40vw">
        <h5>The Remote Actions included configured will be enabled automatically during provisioning process for the selected controller and tenant.</h5>
    </div>
    <div style="text-align:right; float:right">
        <h5>**A PBI must be created and assigned to anyone from DevOps Team for deploying new changes.**</h5>
    </div>
</div>
<provisioningtemplate-list [list]="mergedList" [isEditableMethod]="isEditable" (onReload)="onReload($event)"></provisioningtemplate-list>